var mobileBreakpoint = window.matchMedia('(max-width: 1000px)');

function updateMenuAriaHidden() {
    var menu = document.querySelector('#main-menu');
    if (!menu) return;
    if (mobileBreakpoint.matches && !menu.classList.contains('open')) {
        menu.setAttribute('aria-hidden', 'true');
    } else {
        menu.removeAttribute('aria-hidden');
    }
}

updateMenuAriaHidden();
mobileBreakpoint.addEventListener('change', updateMenuAriaHidden);

var menuToggles = document.querySelectorAll('.menu-button');
Array.prototype.forEach.call(menuToggles, function(menuToggle, i){
	menuToggle.addEventListener('click', function(event){
		event.preventDefault();
		var menu = document.querySelector('#main-menu');
		var isOpen = menu.classList.contains('open');
		
		if (isOpen) {
			// Close menu
			menu.classList.remove('open');
			menuToggle.setAttribute('aria-expanded', 'false');
			menuToggle.setAttribute('aria-label', 'Åpne meny');
			menu.setAttribute('aria-hidden', 'true');
			
			// Return focus to the open button
			var openButton = document.querySelector('.menu-button.open');
			if (openButton) {
				openButton.focus();
			}
		} else {
			// Open menu
			menu.classList.add('open');
			menuToggle.setAttribute('aria-expanded', 'true');
			menuToggle.setAttribute('aria-label', 'Lukk meny');
			menu.setAttribute('aria-hidden', 'false');
			
			// Focus first focusable element in menu
			var firstFocusable = menu.querySelector('a, button');
			if (firstFocusable) {
				firstFocusable.focus();
			}
		}
	});
	
	// Add keyboard support for mobile menu buttons
	menuToggle.addEventListener('keydown', function(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.click();
		}
		if (event.key === 'Escape') {
			var menu = document.querySelector('#main-menu');
			if (menu.classList.contains('open')) {
				this.click();
			}
		}
	});
});

// Focus trapping for mobile menu
function trapFocus(element) {
	var focusableElements = element.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
	var firstFocusable = focusableElements[0];
	var lastFocusable = focusableElements[focusableElements.length - 1];
	
	element.addEventListener('keydown', function(event) {
		// Only trap focus when the menu is in its open state (e.g. mobile)
		if (!element.classList.contains('open')) {
			return;
		}
		if (event.key === 'Tab') {
			if (event.shiftKey) {
				// Shift + Tab
				if (document.activeElement === firstFocusable) {
					event.preventDefault();
					lastFocusable.focus();
				}
			} else {
				// Tab
				if (document.activeElement === lastFocusable) {
					event.preventDefault();
					firstFocusable.focus();
				}
			}
		}
		if (event.key === 'Escape') {
			var menu = document.querySelector('#main-menu');
			var closeButton = menu.querySelector('.menu-button.close');
			if (closeButton) {
				closeButton.click();
			}
		}
	});
}

// Apply focus trapping to mobile menu when it opens
var mobileMenu = document.querySelector('#main-menu');
if (mobileMenu) {
	trapFocus(mobileMenu);
}

var menuItems = document.querySelectorAll('li.menu-item-has-children');
Array.prototype.forEach.call(menuItems, function(el, i){
	// var activatingA = el.querySelector('a');
	// var btn = '<button><span><span class="visuallyhidden">show submenu for “' + activatingA.text + '”</span></span></button>';
	// activatingA.insertAdjacentHTML('afterend', btn);
	el.querySelector('button').addEventListener("click",  function(event){
		var submenu = this.parentNode.querySelector('.sub-menu');
		var submenuId = submenu ? submenu.id : null;
		
		if (this.parentNode.classList.contains("open")) {
			this.parentNode.classList.remove("open");
			this.parentNode.querySelector('a').setAttribute('aria-expanded', "false");
			this.setAttribute('aria-expanded', "false");
			if (submenu) {
				submenu.setAttribute('aria-hidden', "true");
			}
			
		} else {
			this.parentNode.classList.add("open");
			this.parentNode.querySelector('a').setAttribute('aria-expanded', "true");
			this.parentNode.querySelector('button').setAttribute('aria-expanded', "true");
			if (submenu) {
				submenu.setAttribute('aria-hidden', "false");
			}
		}
		event.preventDefault();
	});

	// Add keyboard support for submenu buttons
	el.querySelector('button').addEventListener('keydown', function(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.click();
		}
		if (event.key === 'Escape') {
			this.parentNode.classList.remove("open");
			this.parentNode.querySelector('a').setAttribute('aria-expanded', "false");
			this.setAttribute('aria-expanded', "false");
			var submenu = this.parentNode.querySelector('.sub-menu');
			if (submenu) {
				submenu.setAttribute('aria-hidden', "true");
			}
			this.parentNode.querySelector('a').focus();
		}
	});

	// Handle focus leaving the submenu
	el.addEventListener('focusout', function(event) {
		// Check if the new focus is outside the submenu
		if (!el.contains(event.relatedTarget)) {
				el.className = "has-submenu";
				el.querySelector('a').setAttribute('aria-expanded', "false");
				el.querySelector('button').setAttribute('aria-expanded', "false");
				var submenu = el.querySelector('.sub-menu');
				if (submenu) {
					submenu.setAttribute('aria-hidden', "true");
				}
		}
});
});

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header');
  const scrollThreshold = 10; // Adjust this value to change when the color changes

  function updateHeaderClass() {
    if (window.scrollY > scrollThreshold && header.classList.contains('image')) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  // Check on load
  updateHeaderClass();

  // Check on scroll
  window.addEventListener('scroll', updateHeaderClass);
});